/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateSponsoredRewardRequest } from './CreateSponsoredRewardRequest';
import {
    CreateSponsoredRewardRequestFromJSON,
    CreateSponsoredRewardRequestFromJSONTyped,
    CreateSponsoredRewardRequestToJSON,
    CreateSponsoredRewardRequestToJSONTyped,
} from './CreateSponsoredRewardRequest';

/**
 * 
 * @export
 * @interface UpdateSponsoredCompetitionBody
 */
export interface UpdateSponsoredCompetitionBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateSponsoredCompetitionBody
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSponsoredCompetitionBody
     */
    sponsorBrandName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSponsoredCompetitionBody
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSponsoredCompetitionBody
     */
    promotionImage: string;
    /**
     * 
     * @type {Array<CreateSponsoredRewardRequest>}
     * @memberof UpdateSponsoredCompetitionBody
     */
    rewards: Array<CreateSponsoredRewardRequest>;
    /**
     * 
     * @type {number}
     * @memberof UpdateSponsoredCompetitionBody
     */
    runningMonth: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSponsoredCompetitionBody
     */
    runningYear: number;
    /**
     * URL to the brand's website (to display on competition page)
     * @type {string}
     * @memberof UpdateSponsoredCompetitionBody
     */
    brandUrl: string;
}

/**
 * Check if a given object implements the UpdateSponsoredCompetitionBody interface.
 */
export function instanceOfUpdateSponsoredCompetitionBody(value: object): value is UpdateSponsoredCompetitionBody {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sponsorBrandName' in value) || value['sponsorBrandName'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('promotionImage' in value) || value['promotionImage'] === undefined) return false;
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    if (!('runningMonth' in value) || value['runningMonth'] === undefined) return false;
    if (!('runningYear' in value) || value['runningYear'] === undefined) return false;
    if (!('brandUrl' in value) || value['brandUrl'] === undefined) return false;
    return true;
}

export function UpdateSponsoredCompetitionBodyFromJSON(json: any): UpdateSponsoredCompetitionBody {
    return UpdateSponsoredCompetitionBodyFromJSONTyped(json, false);
}

export function UpdateSponsoredCompetitionBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSponsoredCompetitionBody {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sponsorBrandName': json['sponsorBrandName'],
        'description': json['description'],
        'promotionImage': json['promotionImage'],
        'rewards': ((json['rewards'] as Array<any>).map(CreateSponsoredRewardRequestFromJSON)),
        'runningMonth': json['runningMonth'],
        'runningYear': json['runningYear'],
        'brandUrl': json['brandUrl'],
    };
}

export function UpdateSponsoredCompetitionBodyToJSON(json: any): UpdateSponsoredCompetitionBody {
    return UpdateSponsoredCompetitionBodyToJSONTyped(json, false);
}

export function UpdateSponsoredCompetitionBodyToJSONTyped(value?: UpdateSponsoredCompetitionBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sponsorBrandName': value['sponsorBrandName'],
        'description': value['description'],
        'promotionImage': value['promotionImage'],
        'rewards': ((value['rewards'] as Array<any>).map(CreateSponsoredRewardRequestToJSON)),
        'runningMonth': value['runningMonth'],
        'runningYear': value['runningYear'],
        'brandUrl': value['brandUrl'],
    };
}

